var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDeleteItem = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.935 2.016A2 2 0 0 0 9 .5c-.932 0-1.71.643-1.931 1.516H3.5v1h11v-1zM9 1.5c.382 0 .705.221.875.516H8.142A.99.99 0 0 1 9 1.5M13 4h1v10.516c0 .827-.673 1.5-1.5 1.5h-7c-.827 0-1.5-.673-1.5-1.5V4h1v10.516a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5zM8 5v8H7V5zm3 0v8h-1V5z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDeleteItem);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/delete_item.svg";